
var React = require("react");
var CardActionItem = require("./generic/CardActionItem.jsx");
var DataActionUtil = require("./../../util/DataActionUtil.js");

class RestoreButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        return <CardActionItem 
                    {...this.props}
                    text="Restore"
                    iconText={
                        <React.Fragment>
                             <svg width="17px" height="20px" viewBox="0 0 17 20" xmlns="http://www.w3.org/2000/svg">
                                 <use xlinkHref='#restore' />
                             </svg>
                         </React.Fragment>
                    }
                    tooltip="Restore from trash"
                    action={DataActionUtil.restoreAsset}
                >
               </CardActionItem>
    }
}

module.exports = RestoreButton;
